import {DELETE_OFFERS_START} from "../../types";

export const delete_offers = (payload) => ({
    type: DELETE_OFFERS_START,
    payload,
});
